import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import bookmeLandingConfig from '../config/bookmeLanding.config';

const safeObj = (value, fallback) => (value && typeof value === 'object' ? value : fallback);

const normalizeSettings = (data = {}) => ({
  ...bookmeLandingConfig,
  ...data,
  branding: {
    ...(bookmeLandingConfig.branding || {}),
    ...safeObj(data.branding, {}),
  },
  hero: {
    ...(bookmeLandingConfig.hero || {}),
    ...safeObj(data.hero, {}),
  },
  sections: {
    ...(bookmeLandingConfig.sections || {}),
    ...safeObj(data.sections, {}),
  },
  theme: {
    ...(bookmeLandingConfig.theme || {}),
    ...safeObj(data.theme, {}),
  },
  whatsapp: {
    ...(bookmeLandingConfig.whatsapp || {}),
    ...safeObj(data.whatsapp, {}),
  },
  features: Array.isArray(data.features) ? data.features : bookmeLandingConfig.features || [],
  testimonials: Array.isArray(data.testimonials) ? data.testimonials : bookmeLandingConfig.testimonials || [],
  gallery: Array.isArray(data.gallery) ? data.gallery : bookmeLandingConfig.gallery || [],
});

export const useLandingSettings = () => {
  const [settings, setSettings] = useState(() => normalizeSettings(bookmeLandingConfig));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, 'settings', 'landing');
        const snap = await getDoc(docRef);
        if (!snap.exists()) {
          if (isMounted) {
            setSettings(normalizeSettings(bookmeLandingConfig));
            setLoading(false);
          }
          return;
        }
        const data = snap.data() || {};
        if (isMounted) {
          setSettings(normalizeSettings(data));
          setLoading(false);
        }
      } catch (err) {
        console.error('❌ Error cargando landing settings:', err);
        if (isMounted) {
          setError(err);
          setSettings(normalizeSettings(bookmeLandingConfig));
          setLoading(false);
        }
      }
    };

    fetchSettings();
    return () => {
      isMounted = false;
    };
  }, []);

  return { settings, loading, error };
};

export default useLandingSettings;
